import { AlertCircle, RefreshCcw } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/locales/client";

export const StudySetLoadingError = ({
  resetErrorBoundary,
}: {
  resetErrorBoundary: () => void;
}) => {
  const t = useI18n();
  return (
    <div className="flex flex-col h-[400px] w-full">
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>{t("studySet.loadingError.title")}</AlertTitle>
        <AlertDescription className="flex flex-col gap-4">
          <p>{t("studySet.loadingError.description")}</p>
          <Button
            variant="outline"
            size="sm"
            onClick={() => resetErrorBoundary()}
            className="w-fit"
          >
            <RefreshCcw className="mr-2 h-4 w-4" />
            {t("studySet.loadingError.retry")}
          </Button>
        </AlertDescription>
      </Alert>
    </div>
  );
};
